export default __webpack_public_path__ + "static/media/BZ.79c87f6f.svg";